import { formatPrice } from '@/lib/helpers';
import { TService } from '@/models/services';
import { Stack, Text } from '@mantine/core';

export type IPriceCellConfig = {
  included: boolean;
  displayIcon: boolean;
};

export default function ChildServicePriceCellSettings({
  record,
}: {
  record: TService;
  config: IPriceCellConfig;
  onChange: (config: IPriceCellConfig) => void;
}) {
  return (
    <Stack>
      <Text size="xs" fw={500}>
        {record.name}
      </Text>
      <Text size="xs" fw={500}>
        Service Price: {formatPrice(record.price, record.currency)}
      </Text>
      <Text size="xs">
        Included service has no configuration, it inherits configuration from
        package service.
      </Text>
    </Stack>
  );
}
